import { SignUp } from '@clerk/clerk-react';

/**
 * Sign up page using Clerk's pre-built SignUp component.
 */
export default function Register() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-indigo-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <SignUp
          afterSignUpUrl="/dashboard"
          signInUrl="/sign-in"
          redirectUrl="/dashboard"
        />
      </div>
    </div>
  );
}
